import moment from 'moment'
import i18n from '@/i18n/i18n'

const translateCount = (key, count) => i18n.global.t(key, count, { count })


export const dateIsAfter = (date, compareDate) => {
    const data1 = moment(date);
    const data2 = moment(compareDate);
    
    return data1.isAfter(data2);
    
}


export const dateIsBefore = (date, compareDate) => {
    const data2 = moment(compareDate);
    const data1 = moment(date);

    return data1.isBefore(data2)
}


export const formatDate = (date, format = "DD/MM/YYYY") => {
    if (!date) { return '' }
    return moment(date).format(format)
}

export const addDays = (date, days) => {
    if (!date) { return date }
    return moment(date).add(days, 'days');
}

export const addMonths = (date, months) => {
    if (!date) { return date }
    return moment(date).add(months, 'months');
}

export const formatDateTime = (date, addSeconds = false) => {
    if (!date) { return '' }
    return moment(date).format(`DD/MM/YYYY HH:mm${addSeconds ? ':ss' : ''}`)
}


export const chatTimeCount = (data) => {
    if (!data) {
        return ''
    }
    const agora = moment();
    const dataMensagem = moment(data);
    const diferenca = moment.duration(agora.diff(dataMensagem));
    
    if (diferenca.asMinutes() < 1) {
        return i18n.global.t('utils.time.lessThanMinuteAgo');
    } else if (diferenca.asMinutes() < 60) {
        const minutos = Math.floor(diferenca.asMinutes());
        return translateCount('utils.time.minutesAgo', minutos);
    } else if (diferenca.asHours() < 24) {
        const horas = Math.floor(diferenca.asHours());
        return translateCount('utils.time.hoursAgo', horas);
    } else if (diferenca.asDays() < 30) {
        const dias = Math.floor(diferenca.asDays());
        return translateCount('utils.time.daysAgo', dias);
    } else if (diferenca.asWeeks() < 4) {
        const semanas = Math.floor(diferenca.asWeeks());
        return translateCount('utils.time.weeksAgo', semanas);
    } else if (diferenca.asMonths() < 12) {
        const meses = Math.floor(diferenca.asMonths());
        return translateCount('utils.time.moreThanMonthsAgo', meses);
         //`Mais de 1 mês atrás`;
    } else {
        return i18n.global.t('utils.time.moreThanYearAgo');
    }
}

export const tempoDecorrido = (data) => {
    if (!data) {
        return ''
    }
    const agora = moment();
    const dataMensagem = moment(data);
    const diferenca = moment.duration(agora.diff(dataMensagem));
    
    if (diferenca.asHours() < 24) {
        return i18n.global.t('utils.time.lessThan24Hours');
    } else if (diferenca.asDays() <= 30) {
        const dias = Math.floor(diferenca.asDays());
        return translateCount('utils.time.days', dias);
    } else if (diferenca.asWeeks() < 4) {
        const semanas = Math.floor(diferenca.asWeeks());
        return translateCount('utils.time.weeks', semanas);
    } else if (diferenca.asMonths() < 12) {
        const meses = Math.floor(diferenca.asMonths());
        return translateCount('utils.time.moreThanMonths', meses);
    } else {
        return i18n.global.t('utils.time.moreThanYear');
    }
}

export const formatDateTimeApi = (date) => {
    if (!date) { return null }
    return moment(date).format("YYYY-MM-DD HH:mm:ss")
}

export const firstDateOfMonth = (date = new Date()) =>
    new Date(date.getFullYear(), date.getMonth(), 1);

const addMomentFilters = (app) => {
    app.config.globalProperties.$moment = {
        formatDate: formatDate,
        formatDateTime: formatDateTime,
        chatTimeCount: chatTimeCount,
        addDays: addDays,
        addMonths: addMonths,
        tempoDecorrido: tempoDecorrido,
        firstDateOfMonth: firstDateOfMonth,
        dateIsAfter: dateIsAfter,
        dateIsBefore: dateIsBefore
    }
}

export default addMomentFilters

export const formatMonthYear = (value) => {
  if (!value) return ''

  const [year, month] = value.split('-')
  return `${month}/${year}`
}